var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1700_4505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.2319,
    r: 19.5455,
    fill: "#fbfbfb",
    stroke: "#C1C5CF",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6165 28V13C22.6165 12.4477 22.1688 12 21.6165 12H18.2314C17.6791 12 17.2314 12.4477 17.2314 13V28M22.6165 28L22.615 19.0354C22.615 18.483 23.0627 18.0352 23.615 18.0352H27C27.5523 18.0352 28 18.4829 28 19.0352V27C28 27.5523 27.5523 28 27 28H22.6165ZM22.6165 28H17.2314M17.2314 28V23.7183C17.2314 23.166 16.7836 22.7183 16.2314 22.7183H13C12.4477 22.7183 12 23.166 12 23.7183V27C12 27.5523 12.4477 28 13 28H17.2314Z",
    stroke: "#F9009E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1700_4505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.231873)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketExperience);
export default __webpack_public_path__ + "static/media/MarketExperience.6ca4d88de556fe7c17a06b672433e1e9.svg";
export { ForwardRef as ReactComponent };